import SubCategories from "@/views/admin/subcategory/SubCategories";

export default {
  path: "products/subcategories",
  name: "subcategories",
  component: SubCategories,
  props: true,
  meta: {
    requiresAuth: true
  }
};
